import th from 'iview/dist/locale/en-US'
import thE from 'element-ui/lib/locale/lang/th'

const thTH = Object.assign({
  'menu': {
    'home': 'ที่หน้าแรก',
    'system': 'การตั้งค่าระบบ',
    'system_management': {
      'Role': 'หน้าที่',
      'Department': 'แผนก',
      'Account': 'บัญชี',
      'WorkTime': 'ช่วงเวลาการทำงาน',
      'WorkType': 'ประเภทงาน',
      'RoleEdit': 'แก้ไขหน้าที่',
      'DepartmentEdit': 'แก้ไขแผนก',
      'AccountEdit': 'แก้ไขข้อมูล',
      'WorkTimeEdit': 'แก้ไขช่วงเวลาการทำงาน',
      'WorkTypeEdit': 'แก้ไขประเภทพนักงาน',
      'systeminfo': 'ข้อมูลระบบ',
      'SystemAuth': 'ให้สิทธิ์การจัดการ'
    },
    'Device': 'การตั้งค่าอุปกรณ์',
    'Device_management': {
      'RouterList': 'เราต์เตอร์',
      'RouterEdit': 'แก้ไขเราต์เตอร์',
      'Collector': 'เครื่องจักร',
      'CollectorEdit': 'แก้ไขเครื่องจักร',
      'CollectorGroup': 'กลุ่มเครื่องจักร',
      'CollectorGroupEdit': 'แก้ไขการจัดกลุ่มเครื่องจักร'
    },
    'Card': 'การตั้งค่าการ์ด',
    'CardEdit': 'แก้ไขการ์ด',
    'People': 'การตั้งค่าบุคคล',
    'PeopleEdit': 'แก้ไขบุคคล',
    'Product': 'การตั้งค่าผลิตภัณฑ์',
    'ProductEdit': 'แก้ไขผลิตภัณฑ์',
    'Order': 'การตั้งค่าการสั่งซื้อ',
    'OrderEdit': 'แก้ไขการสั่งซื้อ',
    'Plan': 'การวางแผนผลิตภัณฑ์',
    'Plan_Management': {
      'Production_plan': 'การวางแผนการสั่งซื้อ',
      'Production_management': 'การจัดเรียงการสั่งซื้อ',
      'Production_order': 'กำหนดการการสั่งซื้อ'
    },
    'Monitor': 'การตรวจสอบแบบเรียลไทม์',
    'Monitor_Monitoring': {
      'Collector': 'สถานะเครื่องจักร',
      'Order': 'สถานะการสั่งซื้อ'
    },
    'Data': 'รายงาน',
    'Data_output': {
      'Order': 'ประวัติการสั่งซื้อ',
      'device': 'ประวัติเครื่องจักร',
      'Worker': 'ประวัติพนักงาน',
      'MaintainList': 'ประวัติการบำรุงรักษา',
      'MaintainEdit': 'แก้ไขการบำรุงรักษา'
    },
    'Setting': 'การตั้งค่าผู้ใช้'
  },
  'system': {
    'Account': {
      'New_account': 'บัญชีใหม่',
      'edit_account': 'แก้ไขข้อมูล',
      'please_enter': 'โปรดใส่ข้อมูล',
      'please_choose': 'โปรดเลือก',
      'Return_to_account_list': 'กลับสู่หน้ารายการบัญชี',
      'User_name': 'ชื่อผู้ใช้',
      'User_name_message': 'โปรดใส่ชื่อผู้ใช้',
      'Name': 'ชื่อ-นามสกุล',
      'Name_message': 'โปรดใส่ชื่อ-นามสกุล',
      'Role': 'หน้าที่',
      'Role_message': 'โปรดเลือกหน้าที่',
      'Worker_number': 'หมายเลขพนักงาน',
      'Department': 'แผนก',
      'Department_message': 'โปรดเลือกแผนก',
      'Telephone': 'โทรศัพท์',
      'Email': 'อีเมล',
      'QQ': '- (ไทยเหมือนจะไม่มี QQ ค่ะ)',
      'Wechat': 'วีแชท',
      'telephone': 'โทรศัพท์:',
      'email': 'อีเมล:',
      'qq': '- (ไทยเหมือนจะไม่มี QQ ค่ะ)',
      'wechat': 'วีแชท:',
      'save': 'บันทึก',
      'index': 'หมายเลข',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'reseat': 'ตั้งเครื่องใหม่',
      'error': 'เกิดข้อผิดพลาด',
      'error_message1': '<p>บัญชีซ้ำ</p>',
      'error_message2': '<p>บัญชีซ้ำ</p>',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?'
    },
    'Department': {
      'New_Department': 'แผนกใหม่',
      'edit_Department': 'แก้ไขแผนก',
      'index': 'หมายเลข',
      'Department': 'แผนก',
      'Authorization': 'การให้สิทธิ์',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'please_enter': 'โปรดใส่ข้อมูล',
      'Return_to_depatement_list': 'กลับสู่หน้ารายการแผนก',
      'name': 'ชื่อ',
      'Move_left': 'เลื่อนไปทางซ้าย',
      'Move_right': 'เลื่อนไปทางขวา',
      'save': 'บันทึก',
      'All_authorization': 'การให้สิทธิ์ทั้งหมด',
      'Department_authorization': 'สิทธิ์ของแผนก'
    },
    'Role': {
      'New_Role': 'หน้าที่ใหม่',
      'edit_Role': 'แก้ไขหน้าที่',
      'index': 'หมายเลข',
      'Role': 'หน้าที่',
      'Authorization': 'การให้สิทธิ์',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'please_enter': 'โปรดใส่ข้อมูล',
      'Return_to_role_list': 'กลับสู่หน้ารายการหน้าที่',
      'name': 'ชื่อ',
      'Move_left': 'เลื่อนไปทางซ้าย',
      'Move_right': 'เลื่อนไปทางขวา',
      'save': 'บันทึก',
      'All_authorization': 'การให้สิทธิ์ทั้งหมด',
      'Role_authorization': 'การให้สิทธิ์หน้าที่'
    },
    'workTime': {
      'New_workTime': 'ช่วงเวลาการทำงานใหม่',
      'edit_workTime': 'แก้ไขช่วงเวลาการทำงาน',
      'index': 'หมายเลข',
      'name': 'ชื่อ',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'please_enter': 'โปรดใส่ข้อมูล',
      'please_choose': 'โปรดเลือกเวลา',
      'startTime': 'เวลาเริ่มต้น',
      'endTime': 'เวลาที่สิ้นสุด',
      'Return_to_workTime_list': 'กลับสู่หน้ารายการช่วงเวลาการทำงาน',
      'save': 'บันทึก'
    },
    'workType': {
      'New_workType': 'ประเภทพนักงานใหม่',
      'edit_workType': 'แก้ไขประเภทพนักงาน',
      'index': 'หมายเลข',
      'name': 'ชื่อ',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'please_enter': 'โปรดใส่ข้อมูล',
      'Return_to_workType_list': 'กลับสู่หน้ารายการ',
      'save': 'บันทึก',
      'yes': 'ใช่',
      'no': 'ไม่',
      'outputValid': 'คำนวณผลผลิต',
      'monopoly': 'ยึดครองเครื่องจักร',
      'maintain': 'โหมดการบำรุงรักษา',
      'warn': 'ปิดสัญญาณเตือนภัย',
      'Sorting': 'การเรียงลำดับ',
      'display': 'จอแสดงผล',
      'malfunction': 'การคำนวณผิดพลาด',
      'remark': 'หมายเหตุ'
    },
    'SystemAuth': {
      'Information': 'ข้อมูลพื้นฐาน',
      'systemVersion': 'รุ่นของระบบ:',
      'systemDealTime': 'วันหมดอายุ',
      'please_enter': 'โปรดใส่ข้อมูล',
      'save': 'บันทึก',
      'save_success': 'การบันทึกสำเร็จ',
      'systemAuthCode': 'รหัสการให้สิทธิ์'
    },
    'SystemInfo': {
      'Information': 'ข้อมูลพื้นฐาน',
      'Contect': 'ช่องทางการติดต่อ',
      'systemName': 'ชื่อระบบ:',
      'please_enter': 'โปรดใส่ข้อมูล',
      'name': 'ชื่อบริษัท:',
      'contact': 'ชื่อผู้ติดต่อ:',
      'address': 'ที่อยู่บริษัท:',
      'phone': 'เบอร์ติดต่อ:',
      'fax': 'แฟกซ์:',
      'eMail': 'อีเมล:',
      'save': 'บันทึก',
      'save_success': 'การบันทึกสำเร็จ',
      'warnLimitTime': 'ปิดช่วงเวลาสัญญาณเตือนภัย'
    }
  },
  'device': {
    'collector': {
      'New_collector': 'เครื่องจักรใหม่',
      'edit_collector': 'แก้ไขเครื่องจักร',
      'Return_to_collector_list': 'กลับสู่หน้ารายการเครื่องจักร',
      'name': 'ชื่อ',
      'deviceNo': 'สิ่งของ',
      'routerID': 'เราต์เตอร์',
      'type': 'ประเภทเครื่องจักร',
      'computeType': 'วิธีการคำนวณการผลิต',
      'roller': 'ลูกกลิ้ง',
      'weft_density': 'ความหนาแน่นของเส้นด้ายทางขวาง',
      'length': 'เส้นรอบวงลูกกลิ้ง',
      'count': 'หมายเลขสายพาน',
      'width': 'ความกว้างสายพาน',
      'deviceCompany': 'ผู้ผลิต',
      'deviceModel': 'ต้นแบบเครื่องจักร',
      'buyTime': 'เวลาซื้อ',
      'deviceLifeTime': 'อายุการใช้งาน (ปี)',
      'please_enter': 'โปรดใส่ข้อมูล',
      'please_enter_mm': 'โปรดใส่ข้อมูล (หน่วย:มิลลิเมตร)',
      'save': 'บันทึก',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'error': 'เกิดข้อผิดพลาด',
      'error_message1': '<p>ข้อมูลไม่ครบถ้วน</p>',
      'error_message2': 'ต้องเป็นจำนวนเต็ม',
      'remark': 'หมายเหตุ',
      'Message': {
        'name': 'โปรดใส่ชื่อ',
        'deviceNo': 'โปรดใส่หมายเลข',
        'computeType': 'โปรดเลือกวิธีการคำนวณ',
        'routerID': 'โปรดใส่เราต์เตอร์',
        'length': 'โปรดใส่เส้นรอบวงลูกกลิ้ง',
        'count': 'โปรดใส่หมายเลขสายพาน',
        'width': 'โปรดใส่ความกว้าง'
      }
    },
    'group': {
      'New_group': 'กลุ่มเครื่องจักรใหม่',
      'edit_group': 'แก้ไขการจัดกลุ่มเครื่องจักร',
      'Return_to_group_list': 'กลับสู่หน้ารายการกลุ่มเครื่องจักร',
      'please_enter': 'โปรดใส่ข้อมูล',
      'save': 'บันทึก',
      'operating': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'index': 'หมายเลข',
      'name': 'ชื่อ',
      'devices': 'ได้เลือกแล้ว',
      'chosen': 'เครื่องจักร',
      'remark': 'หมายเหตุ',
      'width': 'ความกว้าง',
      'router': 'เราต์เตอร์'
    },
    'router': {
      'New_router': 'เราต์เตอร์ใหม่',
      'edit_router': 'แก้ไขเราต์เตอร์',
      'Return_to_router_list': 'กลับสู่หน้ารายการเราต์เตอร์',
      'please_enter': 'โปรดใส่ข้อมูล',
      'index': 'หมายเลข',
      'name': 'รหัสเราต์เตอร์',
      'AnotherName': 'ชื่อเราต์เตอร์',
      'linkType': 'ประเภทเครือข่าย',
      'channel': 'ช่องสัญญาณ',
      'remark': 'หมายเหตุ',
      'save': 'บันทึก',
      'action': 'การดำเนินการ',
      'edit': 'แก้ไข',
      'delete': 'ลบทิ้ง',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'mod': 'ประเภทเครือข่าย',
      'Lan': 'เครือข่ายภายใน',
      'Internet': 'อินเทอร์เน็ต',
      'time': 'จัดเตรียมใหม่',
      'save_success': 'ระบบและตัวเก็บรวบรวมจัดเรียงใหม่เรียบร้อยแล้ว'
    }
  },
  'Card': {
    'New_Card': 'การ์ดใหม่',
    'edit_Card': 'แก้ไขการ์ด',
    'Return_to_Card_list': 'กลับสู่หน้ารายการบัตร',
    'please_enter': 'โปรดใส่ข้อมูล',
    'index': 'หมายเลข',
    'userName': 'เจ้าของ',
    'cardNo': 'รหัสการ์ด',
    'workTypeName': 'ประเภทงาน',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'delete': 'ลบทิ้ง',
    'delete_message': 'ต้องการลบทิ้งหรือไม่?',
    'save': 'บันทึก',
    'error': 'เกิดข้อผิดพลาด',
    'error_message1': '<p>บัตรซ้ำ</p>',
    'error_message2': '<p>ข้อมูลไม่ครบถ้วน</p>'
  },
  'Product': {
    'New_Product': 'ผลิตภัณฑ์ใหม่',
    'edit_Product': 'แก้ไขผลิตภัณฑ์',
    'Return_to_Product_list': 'กลับสู่หน้ารายการผลิตภัณฑ์',
    'please_enter': 'โปรดใส่ข้อมูล',
    'index': 'หมายเลข',
    'productNo': 'สิ่งของ',
    'name': 'ชื่อ',
    'latDensity': 'ความหนาแน่นของเส้นด้ายทางขวาง',
    'kaidu': 'ความตึง',
    'width': 'ความกว้าง',
    'specifications': 'ข้อจำกัด',
    'valid': 'มีประสิทธิภาพ',
    'yes': 'ใช่',
    'no': 'ไม่',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'delete': 'ลบทิ้ง',
    'delete_message': 'ต้องการลบทิ้งหรือไม่?',
    'save': 'บันทึก',
    'error': 'เกิดข้อผิดพลาด',
    'error_message': '<p>ข้อมูลไม่ครบถ้วน</p>',
    'please_enter_kaidu': 'โปรดใส่ข้อมูล (มากกว่าหรือเท่ากับ 1)',
    'please_enter_mm': 'โปรดใส่ข้อมูล (หน่วย:มิลลิเมตร)',
    'please_enter_latDensity': 'โปรดใส่ข้อมูล (หน่วย:welf/cm)',
    'Message': {
      'productNo': 'โปรดใส่หมายเลขผลิตภัณฑ์',
      'name': 'โปรดใส่ชื่อ',
      'latDensity': 'โปรดเลือกความหนาแน่นของเส้นด้ายทางขวาง',
      'kaidu': 'โปรดใส่ความตึง',
      'width': 'โปรดใส่ความกว้าง'
    }
  },
  'Order': {
    'New_Order': 'คำสั่งซื้อใหม่',
    'edit_Order': 'แก้ไขการสั่งซื้อ',
    'Return_to_Order_list': 'กลับสู่หน้ารายการคำสั่งซื้อ',
    'please_enter': 'โปรดใส่ข้อมูล',
    'please_enter_date': 'โปรดใส่วันที่',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'delete': 'ลบทิ้ง',
    'save': 'บันทึก',
    'error': 'เกิดข้อผิดพลาด',
    'error_message1': '<p>ยังไม่มีการเพิ่มผลิตภัณฑ์ลงในการสั่งซื้อ</p>',
    'error_message2': '<p>ยังไม่ได้กรอกข้อมูลการสั่งซื้อ</p>',
    'error_message3': '<p>ปริมาณยังไม่ครบถ้วน</p>',
    'error_message4': '<p>หน่วยไม่สมบูรณ์</p>',
    'error_message5': '<p>วันที่จัดส่งยังไม่เสร็จสมบูรณ์</p>',
    'error_message6': '<p>請先選擇左側產品</p>',
    'delete_message': 'ต้องการลบทิ้งหรือไม่?',
    'change_message': 'ต้องการเปิดเคสหรือไม่?',
    'orderNo': 'เลขที่การสั่งซื้อ',
    'customer': 'ลูกค้า',
    'ordersTime': 'วันที่สั่งซื้อ',
    'salesman': 'ยอดการขาย',
    'index': 'หมายเลข',
    'productNo': 'หมายเลขการผลิต',
    'num': 'จำนวน',
    'unit': 'หน่วย',
    'attritionRate': 'อัตราความเสียหาย (%)',
    'deliveryTime': 'วันที่จัดส่งใบสั่ง',
    'remark': 'หมายเหตุ',
    'add': 'เพิ่มในการสั่งซื้อ',
    'Product_list': 'รายการผลิตภัณฑ์',
    'search': 'สิ่งของ/ชื่อ',
    'No_scheduling': 'ไม่มีการจัดกำหนดการ',
    'Not_production': 'ไม่นำไปผลิต',
    'Producting': 'ดำเนินการในการผลิต',
    'Case_closed': 'จบงาน',
    'name': 'ชื่อ',
    'Meter': 'เมตร',
    'Yard': 'สนาม',
    'Gross': 'ยอดรวม',
    'status': 'สถานภาพ',
    'Message': {
      'orderNo': 'โปรดใส่หมายเลขผลิตภัณฑ์',
      'ordersTime': 'โปรดใส่วันที่สั่งซื้อ',
      'customer': 'โปรดใส่ชื่อลูกค้า',
      'salesman': 'โปรดใส่ชื่อพนักงานขาย'
    }
  },
  'Login': {
    'username': 'โปรดใส่ชื่อผู้ใช้',
    'password': 'โปรดใส่รหัสผ่านของคุณ',
    'systemCode': 'โปรดใส่รหัสระบบ',
    'language': '請選擇語言',
    'login': 'เข้าสู่ระบบ',
    'system': 'เข้าระบบ',
    'changePw': 'เปลี่ยนรหัสผ่าน',
    'logout': 'ออกจากระบบ',
    'Information': 'การตั้งค่าส่วนบุคคล'
  },
  'ChangePw': {
    'oldPassword': 'ใส่รหัสผ่านอันเก่า:',
    'newPassword': 'ใส่รหัสผ่านอันใหม่',
    'comfirmPassword': 'ยืนยันรหัสผ่านใหม่',
    'save': 'บันทึก',
    'error': 'รหัสผ่านไม่สอดคล้องกัน',
    'success': 'การแก้ไขสำเร็จ',
    'ChangePw': 'เปลี่ยนรหัสผ่าน'
  },
  'monitor': {
    'Collector': {
      'index': 'หมายเลข',
      'name': 'ชื่อ',
      'group': 'กลุ่ม',
      'deviceNo': 'สิ่งของ',
      'rpm': 'ความเร็วรอบเครื่องจักร',
      'status': 'สถานะเครื่องจักร',
      'status1': 'สถานะอุปกรณ์',
      'error': 'ข้อมูลผิดพลาด',
      'worker': 'พนักงาน',
      'workType': 'สถานะการ์ด',
      'lastTime': 'เวลา',
      'timeout': 'ออฟไลน์',
      'trial': 'การทดลอง',
      'standby': 'เตรียมพร้อม',
      'run': 'กำลังปฏิบัติหน้าที่อยู่',
      'orderNo': 'เลขที่การสั่งซื้อ',
      'producNo': 'หมายเลขผลิตภัณฑ์',
      'stop': 'เตรียมพร้อม',
      'warp': 'เส้นด้ายทางยาว',
      'weft': 'เส้นด้ายทางขวาง',
      'thread': 'ด้าย',
      'roll': 'ลูกกลิ้ง'
    },
    'Order': {
      'index': 'หมายเลข',
      'orderNo': 'เลขที่การสั่งซื้อ',
      'producNo': 'หมายเลขผลิตภัณฑ์',
      'salesman': 'ยอดการขาย',
      'ordersTime': 'วันที่สั่งซื้อ',
      'output': 'ผลิตผลที่ได้',
      'num': 'ปริมาณการสั่งซื้อ',
      'unit': 'หน่วย',
      'countdata': 'หมายเลขเครื่องจักร',
      'name': 'ชื่อ',
      'rpm': 'ความเร็วรอบเครื่องจักร',
      'worker': 'พนักงาน',
      'workType': 'สถานะการ์ด',
      'DailyOutput': 'ปริมาณที่ผลิตได้วันนี้',
      'deliveryTime': 'วันที่จัดส่งสินค้า',
      'today': 'ปริมาณที่ผลิตได้วันนี้',
      'completed': '已生產完成',
      'fastestdelivery': '預估交期',
      'please_enter_date1': 'วันที่เริ่มต้นของการส่งสินค้า',
      'please_enter_date2': 'วันที่สิ้นสุดของการส่งสินค้า',
      'Meter': 'เมตร',
      'Yard': 'สนาม',
      'Gross': 'ยอดรวม'
    }
  },
  'data': {
    'Device': {
      'name': 'เครื่องจักร',
      'date': 'วันที่',
      'group': 'กลุ่ม',
      'output': 'ผลิตผลที่ได้',
      'unit': 'หน่วย',
      'runTotalTime': 'เวลาทำงานทั้งหมด',
      'stopTime': 'หยุดเวลา',
      'stopTotalTime': 'หยุดเวลาทั้งหมด',
      'error1Time': 'จำนวนครั้งที่ผิดพลาดของเส้นด้ายแนวดิ่ง',
      'error1TotalTime': 'เวลาที่ผิดพลาดของเส้นด้ายแนวดิ่ง',
      'error2Time': 'จำนวนครั้งที่ผิดพลาดของเส้นด้ายทางขวาง',
      'error2TotalTime': 'เวลาที่ผิดพลาดของเส้นด้ายทางขวาง',
      'error3Time': '',
      'error3TotalTime': '',
      'error4Time': '',
      'error4TotalTime': '',
      'S': 'วินาที',
      'M': 'นาที',
      'H': 'ชั่วโมง',
      'D': 'วัน',
      'Meter': 'เมตร',
      'output_report': 'รายงานคำนวณการผลิต',
      'run_report': 'รายงานสถานะการปฏิบัติหน้าที่',
      'please_enter': 'โปรดเลือก',
      'please_enter_date': 'โปรดเลือกวันที่',
      'start_date': 'วันที่เริ่มต้น',
      'end_date': 'วันที่สิ้นสุด',
      'ok': 'บันทึก',
      'out': 'ส่งออก',
      'status': 'สถานะการทำงาน'
    },
    'Order': {
      'orderNo': 'เลขที่การสั่งซื้อ',
      'productNo': 'หมายเลขผลิตภัณฑ์',
      'collectorName': 'เครื่องจักร',
      'salesman': 'ยอดการขาย',
      'customer': 'ลูกค้า',
      'ordersTime': 'วันที่สั่งซื้อ',
      'productTime': 'เวลาการผลิต',
      'output': 'ผลลัพธ์ปัจจุบัน',
      'target': 'เป้าหมายส่งออก',
      'num': 'ปริมาณการสั่งซื้อ',
      'unit': 'หน่วย',
      'deliveryTime': 'วันที่จัดส่งใบสั่ง',
      'Meter': 'เมตร',
      'Yard': 'สนาม',
      'Gross': 'ยอดรวม',
      'Order_report': 'รายงานการสั่งซื้อ',
      'ok': 'บันทึก',
      'out': 'ส่งออก',
      'please_enter': 'โปรดเลือก',
      'please_enter_date': 'โปรดเลือกวันที่',
      'start_date': 'วันที่เริ่มต้น',
      'end_date': 'วันที่สิ้นสุด',
      'time_range': 'Time range',
      'No_scheduling': 'ไม่มีการจัดกำหนดการ',
      'Not_production': 'ไม่นำไปผลิต',
      'Producting': 'ดำเนินการในการผลิต',
      'Case_closed': 'จบงาน',
      'status': 'สถานภาพ',
      'history': 'ประวัติการสั่งซื้อ'
    }
  },
  'setting': {
    'Basic_Information': 'ข้อมูลพื้นฐาน',
    'company_information': 'ข้อมูลบริษัท:',
    'Contact_information': 'ช่องทางการติดต่อ',
    'save': 'บันทึก',
    'please_enter': 'โปรดใส่ข้อมูล',
    'username': 'ชื่อผู้ใช้:',
    'name': 'ชื่อ-นามสกุล:',
    'company': 'บริษัท:',
    'workNo': 'หมายเลขงาน',
    'department': 'แผนก',
    'workPosition': 'ตำแหน่ง:',
    'role': 'หน้าที่:',
    'phone': 'โทรศัพท์:',
    'eMail': 'อีเมล:',
    'qq': '- (ไทยเหมือนจะไม่มี QQ ค่ะ)',
    'wechat': 'วีแชท:',
    'System_setting': 'การตั้งค่าระบบ',
    'language': 'ภาษา',
    'zhcn': '簡體中文',
    'zhtw': '繁體中文',
    'enUS': 'English',
    'jaJP': '日本語',
    'viVN': 'Việt Nam - Tiếng việt',
    'thTH': 'ไทย - ไทย (แปรตรงตัว)'
  },
  'plan': {
    'Collector': {
      'search': 'ชื่อเครื่องจักร',
      'name': 'เครื่องจักร',
      'one': 'รอบที่ 1',
      'two': 'รอบที่ 2',
      'three': 'รอบที่ 3',
      'four': 'รอบที่ 4',
      'fiv': 'รอบที่ 5',
      'six': 'รอบที่ 6',
      'orderNo': 'เลขที่การสั่งซื้อ',
      'productNo': 'หมายเลขผลิตภัณฑ์',
      'row': 'หมายเลขสายพาน',
      'delete_message': 'คุณแน่ใจหรือไม่ว่าต้องการหยุดการผลิต?',
      'yes': 'เริ่มต้น',
      'no': 'หยุด'
    },
    'Order': {
      'orderNo': 'เลขที่การสั่งซื้อ',
      'customer': 'ลูกค้า',
      'ordersTime': 'วันที่สั่งซื้อ',
      'salesman': 'ยอดการขาย',
      'index': 'หมายเลข',
      'productNo': 'หมายเลขการผลิต',
      'num': 'จำนวน',
      'unit': 'หน่วย',
      'attritionRate': 'อัตราความเสียหาย (%)',
      'output': 'จำนวนที่เสร็จสิ้น',
      'deliveryTime': 'วันที่จัดส่ง',
      'action': 'การดำเนินการ',
      'Meter': 'เมตร',
      'Yard': 'สนาม',
      'Gross': 'ยอดรวม',
      'delete_message': 'คุณแน่ใจหรือไม่ว่าต้องการปิดการสั่งซื้อ?',
      'case1': 'ปิดยอดการขาย',
      'case2': 'จบงาน'
    },
    'Production': {
      'productNo': 'หมายเลขผลิตภัณฑ์',
      'productName': '產品名稱',
      'deliveryTime': 'วันที่จัดส่งใบสั่ง',
      'num': 'จำนวน',
      'name': 'ชื่อเครื่องจักร',
      'count': 'หมายเลขสายพาน',
      'width': 'ความกว้าง',
      'collectorName': 'ชื่อเครื่องจักร',
      'orderNo': 'เลขที่การสั่งซื้อ',
      'planIndex': 'รอบ',
      'row': 'หมายเลขสายพาน',
      'action': 'การดำเนินการ',
      'delete': 'ลบทิ้ง',
      'error': 'เกิดข้อผิดพลาด',
      'error_message': '<p>ยังไม่ได้เลือกประเภท</p>',
      'planClick': 'รายการแผนการผลิต',
      'please_enter': 'โปรดใส่ข้อมูล',
      'deviceNo': 'สิ่งของ',
      'save': 'บันทึก',
      'save1': 'ส่งการสั่งซื้อ',
      'save2': 'ใส่คำสั่งซื้อ',
      'save3': 'ลำดับขนาน',
      'No_scheduling': 'ไม่มีการจัดกำหนดการ',
      'Not_production': 'ไม่นำไปผลิต',
      'Producting': 'ดำเนินการในการผลิต',
      'Case_closed': 'จบงาน',
      'status': 'สถานภาพ',
      'no': 'หยุด',
      'delete_message': 'ต้องการลบทิ้งหรือไม่?',
      'searchCollector': 'ชื่อเครื่องจักร',
      'chooose_order': '1.選擇訂單',
      'choose_device': '2.選擇機台',
      'choose_plan': '3.排產計畫',
      'list': 'รายการแผนการผลิต',
      'message': '此產品已經結案'
    }
  },
  'People': {
    'index': 'หมายเลข',
    'name': 'ชื่อ-นามสกุล',
    'workNo': 'หมายเลขพนักงาน',
    'sex': 'เพศ',
    'boy': 'ชาย',
    'girl': 'หญิง',
    'phone': 'โทรศัพท์',
    'entryTime': 'เวลาเข้างาน',
    'wechat': 'วีแชท',
    'qq': '- (ไทยเหมือนจะไม่มี QQ ค่ะ)',
    'working': 'ในงาน',
    'working1': 'ในงาน',
    'working2': 'การออกไป',
    'yes': 'ใช่',
    'no': 'ไม่',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'edit_People': 'แก้ไขข้อมูลพนักงาน',
    'Return_to_People_list': 'กลับสู่หน้ารายชื่อพนักงาน',
    'please_enter': 'โปรดใส่ข้อมูล',
    'please_enter_date': 'โปรดเลือกวันที่',
    'save': 'บันทึก'
  },
  'Maintain': {
    'index': 'หมายเลข',
    'DeviceName': 'ชื่อเครื่องจักร',
    'username': 'ผู้ปฏิบัติการ',
    'startTime': 'เวลาเริ่มต้น',
    'endTime': 'เวลาที่สิ้นสุด',
    'remark': 'หมายเหตุ',
    'action': 'การดำเนินการ',
    'edit': 'แก้ไข',
    'edit_Maintain': 'แก้ไขบันทึกการบำรุงรักษา',
    'Return_to_Maintain_list': 'กลับสู่หน้ารายการการบำรุงรักษา',
    'save': 'บันทึก',
    'please_enter': 'โปรดใส่ข้อมูล',
    'please_enter_date1': 'วันที่เริ่มต้นของเวลาเริ่มต้น',
    'please_enter_date2': 'วันที่สิ้นสุดของเวลาเริ่มต้น'
  },
  'Permission': {
    'super_admin': 'การตั้งค่าระบบขั้นสุด',
    'system': 'การตั้งค่าระบบ',
    'device': 'การตั้งค่าอุปกรณ์',
    'card': 'การตั้งค่าการ์ด',
    'people': 'การตั้งค่าบุคคล',
    'product': 'การตั้งค่าผลิตภัณฑ์',
    'order': 'การตั้งค่าการสั่งซื้อ',
    'production_plan': 'การวางแผนผลิตภัณฑ์',
    'monitor': 'การตรวจสอบแบบเรียลไทม์',
    'report_export': 'รายงาน',
    'R': 'อ่าน',
    'W': 'เขียน',
    'RW': 'อ่านและเขียน'
  }
}, th, thE)

export default thTH



// WEBPACK FOOTER //
// ./src/lang/th-TH.js